import React from 'react';
import clsx from 'clsx';

const CrumbLink = ({
  href,
  text,
  isLast,
  isDark,
  position = '2',
  themeBlue,
  ...linkProps
}) => {
  return (
    <li
      className="flex items-baseline"
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
    >
      <a
        href={href}
        className={`flex items-center mr-2 ${
          isDark ? 'text-white' : 'text-black'
        } ${themeBlue && 'text-brandSecondary'} ${
          isLast && 'last-breadcrumb-item'
        }`}
        property="item"
        typeof="WebPage"
        itemProp="item"
        title={text}
        {...linkProps}
      >
        <span property="name" itemProp="name">
          {text}
        </span>
        {!isLast && (
          <svg
            fill={`${isDark ? 'white' : 'black'}`}
            className="w-3 h-3"
            width="12"
            height="12"
            enableBackground="new 0 0 32 32"
            id="Layer_1"
            version="1.1"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M24.291,14.276L14.705,4.69c-0.878-0.878-2.317-0.878-3.195,0l-0.8,0.8c-0.878,0.877-0.878,2.316,0,3.194  L18.024,16l-7.315,7.315c-0.878,0.878-0.878,2.317,0,3.194l0.8,0.8c0.878,0.879,2.317,0.879,3.195,0l9.586-9.587  c0.472-0.471,0.682-1.103,0.647-1.723C24.973,15.38,24.763,14.748,24.291,14.276z" />
          </svg>
        )}
        <meta itemProp="position" content={position} />
      </a>
    </li>
  );
};

function BreadCrumb({
  t,
  isDark,
  children,
  forTools,
  hidden = false,
  themeBlue = false,
}) {
  return (
    <div
      className={clsx(
        'breadcrumb-wrap flex p-4 px-8',
        hidden && 'hidden',
        forTools && 'for-tools',
      )}
    >
      <ul
        className="breadcrumb flex"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        <li
          className="flex items-baseline"
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <a
            href="/"
            property="item"
            typeof="WebPage"
            itemProp="item"
            title="Go to Academy for Professional Quality Video Creation."
            className={`mx-2 flex items-center ${
              isDark ? 'text-white' : 'text-black'
            } ${themeBlue && 'text-brandSecondary'}`}
          >
            <span property="name" itemProp="name">
              {t('home')}
            </span>
            <svg
              fill={`${isDark ? 'white' : 'black'}`}
              className="w-3 h-3"
              width="12"
              height="12"
              enableBackground="new 0 0 32 32"
              id="Layer_1"
              version="1.1"
              viewBox="0 0 32 32"
              xmlSpace="preserve"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M24.291,14.276L14.705,4.69c-0.878-0.878-2.317-0.878-3.195,0l-0.8,0.8c-0.878,0.877-0.878,2.316,0,3.194  L18.024,16l-7.315,7.315c-0.878,0.878-0.878,2.317,0,3.194l0.8,0.8c0.878,0.879,2.317,0.879,3.195,0l9.586-9.587  c0.472-0.471,0.682-1.103,0.647-1.723C24.973,15.38,24.763,14.748,24.291,14.276z" />
            </svg>
            <meta itemProp="position" content="1" />
          </a>
        </li>
        {children}
      </ul>
    </div>
  );
}

export { BreadCrumb, CrumbLink };
